module.exports = __webpack_public_path__ + "img/scene-dq.d01b8f62.png";